import React, { useState, useEffect, useRef } from "react";
import { Link, Outlet } from "react-router-dom";
import BulkExport from "../../ActiveSellerList/Component/BulkButton/BulkExport";

const PurchaseHistory = () => {
  //Mulitiple Dropdowns
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isActionOpen, setIsActionOpen] = useState(false);
  const dropdownRef = useRef(null);
  // bulk import popup
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [file, setFile] = useState(null);

  // Handle file selection
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  // Handle file upload
  const handleUpload = () => {
    if (file) {
      // Handle file upload logic here
      console.log("File uploaded:", file);
      setIsPopupOpen(false); // Close popup after upload
    }
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterOpen(false);
        setIsSelectOpen(false);
        setIsMenuOpen(false);
        setIsActionOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [data, setData] = useState([
    {
      purchaseName: "Monthly Subscription",
      transactionStatus: "Success",
      transactionAmount: "$ 2,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Pay Per Contact",
      transactionStatus: "Failed",
      transactionAmount: "₹ 3,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Yearly",
      transactionStatus: "Pending",
      transactionAmount: "€ 456",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Monthly Subscription",
      transactionStatus: "Success",
      transactionAmount: "$ 2,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Pay Per Contact",
      transactionStatus: "Failed",
      transactionAmount: "₹ 3,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Yearly",
      transactionStatus: "Pending",
      transactionAmount: "€ 456",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Monthly Subscription",
      transactionStatus: "Success",
      transactionAmount: "$ 2,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Pay Per Contact",
      transactionStatus: "Failed",
      transactionAmount: "₹ 3,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Yearly",
      transactionStatus: "Pending",
      transactionAmount: "€ 456",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Monthly Subscription",
      transactionStatus: "Success",
      transactionAmount: "$ 2,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Monthly Subscription",
      transactionStatus: "Success",
      transactionAmount: "$ 2,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Pay Per Contact",
      transactionStatus: "Failed",
      transactionAmount: "₹ 3,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Yearly",
      transactionStatus: "Pending",
      transactionAmount: "€ 456",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Monthly Subscription",
      transactionStatus: "Success",
      transactionAmount: "$ 2,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Pay Per Contact",
      transactionStatus: "Failed",
      transactionAmount: "₹ 3,000",
      transactionDate: "03/11/2024",
    },
    {
      purchaseName: "Yearly",
      transactionStatus: "Pending",
      transactionAmount: "€ 456",
      transactionDate: "03/11/2024",
    },
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [idSearch, setIdSearch] = useState("");
  const [statusSearch, setStatusSearch] = useState("");
  const [companySearch, setCompanySearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");
  const [phoneSearch, setPhoneSearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");

  const getStatusClass = (status) => {
    switch (status) {
      case "Success":
        return "bg-[#e1fcef] text-[#38a06c]";
      case "Failed":
        return "bg-[#ffedef] text-[#d12a3e]";
      case "Pending":
        return "bg-[#e9edf5] text-[#5a6376]";

      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedRows(!selectAll ? data.map((row) => row.id) : []);
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const filteredData = data.filter((row) => {
    const matchesId = idSearch
      ? row.id.toLowerCase().includes(idSearch.toLowerCase())
      : true;
    const matchesStatus = statusSearch
      ? row.status.toLowerCase().includes(statusSearch.toLowerCase())
      : true;
    const matchesCompany = companySearch
      ? row.purchaseName.toLowerCase().includes(companySearch.toLowerCase())
      : true;
    const matchesEmail = emailSearch
      ? row.transactionStatus.toLowerCase().includes(emailSearch.toLowerCase())
      : true;
    const matchesPhone = phoneSearch
      ? row.transactionAmount.toLowerCase().includes(phoneSearch.toLowerCase())
      : true;
    const matchesLocation = locationSearch
      ? row.transactionDate.toLowerCase().includes(locationSearch.toLowerCase())
      : true;
    return (
      matchesId &&
      matchesStatus &&
      matchesCompany &&
      matchesEmail &&
      matchesPhone &&
      matchesLocation
    );
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <div className=" w-full">
      <div className="overflow-x-auto w-full">
        <div className="overflow-hidden rounded-lg border-2 border-gray-200 w-full">
          <div className="">
            <h1 className="text-xl text-[#667085] w-full p-4 border-b">
              Purchased History
            </h1>
          </div>

          <div className="flex items-center justify-between px-4">
            <div className="flex gap-6">
              <h1 className="text-[#667085] text-base font-medium">
                <span className="text-oceanBlue">Total Transaction :</span>
                50
              </h1>
            </div>

            <div className="flex items-center">
              <div className="flex justify-end gap-3 my-3">
                <BulkExport content={" Export"} />
                <Pagination />
              </div>
            </div>
          </div>

          <table className="w-full table-auto border-collapse overflow-x-auto ">
            <thead className="bg-[#eeee] ">
              <tr>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 mx-auto">
                  purchase Name
                </th>

                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Transaction Status
                </th>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Transaction Amount
                </th>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Transaction Date
                </th>
              </tr>
              <tr>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Search Purchase Names"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={companySearch}
                    onChange={(e) => setCompanySearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Search Transaction Status"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={emailSearch}
                    onChange={(e) => setEmailSearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Search Transaction Amount"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={phoneSearch}
                    onChange={(e) => setPhoneSearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Search Transaction Date"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={locationSearch}
                    onChange={(e) => setLocationSearch(e.target.value)}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((row, index) => (
                <tr
                  key={index}
                  className={`bg-white  ${
                    selectedRows.includes(row.id) ? "bg-[#f4f7fd]" : ""
                  }`}
                >
                  <td className="p-3 border-2 text-center border-gray-200">
                    {row.purchaseName}
                  </td>

                  <td className="p-3 border-2 text-center border-gray-200">
                    <span
                      className={`inline-block px-5 py-1 text-sm font-semibold rounded-lg ${getStatusClass(
                        row.transactionStatus
                      )}`}
                    >
                      {row.transactionStatus}
                    </span>
                  </td>
                  <td className="p-3 border-2 text-center border-gray-200">
                    {row.transactionAmount}
                  </td>
                  <td className="p-3 border-2 text-center border-gray-200">
                    {row.transactionDate}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Outlet />
        </div>
        <div className="mt-3">
          <Pagination />
        </div>
      </div>
    </div>
  );
};

export default PurchaseHistory;

function Pagination() {
  const [pageSize, setPageSize] = useState(20);

  const handlePageSize = (value) => {
    setPageSize(Number(value));
  };
  return (
    <div>
      {/* Pagination */}
      <div
        className={`border w-fit border-gray-300 border-collapse rounded text-gray-500 flex items-center opacity-100 group-hover:cursor-pointer`}
      >
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${
            pageSize === 20 ? "bg-blue-600 text-white rounded" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          20
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${
            pageSize === 100 ? "bg-blue-600 text-white" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          100
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${
            pageSize === 500 ? "bg-blue-600 text-white" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${
            pageSize === 2500 ? "bg-blue-600 text-white" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          2500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer ${
            pageSize === 5000 ? "bg-blue-600 text-white rounded" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          5000
        </div>
      </div>
    </div>
  );
}
